import React from 'react'

/* Images */
import { logos } from '../Assets/Logos/logos'

const AlterarNome = () => {
  return (
    <>
      <section className="companies-section">
        <div className="companies-container">
          <h1>Conheça Nossas Empresas</h1>
          <div className="companies-logos-container">
            <div className="logo-link">
              <a target="_blank" rel="noreferrer" href="https://ammarhes.com.br/">
                <img
                  className="companies-logos-imgs"
                  src={logos.ammarhesWrite}
                  alt="Logo Ammarhes"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://ammarhes.com.br/"
                className="logo-link-button"
              >
                Clique e Acesse
              </a>
            </div>

            <div className="logo-link">
              <a target="_blank" rel="noreferrer" href="https://ximed.com.br/">
                <img
                  className="companies-logos-imgs"
                  src={logos.ximedCompleto}
                  alt="Logo XIMED"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://ximed.com.br/"
                className="logo-link-button"
              >
                Clique e Acesse
              </a>
            </div>

            <div className="logo-link">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://casaocupacional.com.br/"
              >
                <img
                  className="companies-logos-imgs"
                  src={logos.casaOcupacional}
                  alt="Logo Casa Ocupacional"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://casaocupacional.com.br/"
                className="logo-link-button"
              >
                Clique e Acesse
              </a>
            </div>
            <div className="logo-link">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.agendatecnica.com.br/"
              >
                <img
                  className="companies-logos-imgs"
                  src={logos.agenda}
                  alt="Logo Agenda Técnica"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.agendatecnica.com.br/"
                className="logo-link-button"
              >
                Clique e Acesse
              </a>
            </div>
            <div className="logo-link">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://saude10clinica.com.br/"
              >
                <img
                  className="companies-logos-imgs"
                  src={logos.saude10}
                  alt="Logo Saúde 10"
                  id="saude10"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://saude10clinica.com.br/"
                className="logo-link-button"
              >
                Clique e Acesse
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AlterarNome
